export default {
	utilities: {
		title: "Utilities",
		hint: "Handgeschriebenes TypeScript. Alles, was hier exportiert wird, lässt sich im Code jeder Eigenen Aktion als UTILITIES.<name> aufrufen.",
		privateNotice:
			"Utilities sind projektintern und werden nie über eine Abhängigkeit geteilt, auch wenn die Datei im Paket enthalten ist.",
		saved: "Utilities gespeichert.",
		resetAction: "Zurücksetzen",
		resetConfirm: "Die aktuellen Utilities verwerfen und die Ausgangsdatei wiederherstellen?",
		reset: "Utilities auf die Ausgangsdatei zurückgesetzt.",
	},
};
